module.exports = __webpack_public_path__ + "fonts/fa-regular-400.75721d80.eot";